// src/components/Login.js
import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { TextField } from "./ui/Field";
import Button from "./ui/Button";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  // すでにログイン済みならダッシュボードへ
  if (currentUser) {
    return <Navigate to="/lessons" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/lessons");
    } catch (err) {
      console.error("Login error: ", err);
      setError("メールアドレスまたはパスワードが正しくありません。");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div className="card" style={{ width: "100%", maxWidth: 380, padding: 28 }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 40,
              height: 40,
              borderRadius: 10,
              background: "var(--solid)",
              color: "var(--text-on-solid)",
              fontSize: 20,
              fontWeight: 600,
              marginBottom: 12,
            }}
          >
            R
          </span>
          <h1 style={{ fontSize: 18 }}>RUDO MANAGER</h1>
          <p
            style={{
              margin: "4px 0 0",
              fontSize: 13,
              color: "var(--text-tertiary)",
            }}
          >
            管理パネルにログイン
          </p>
        </div>

        {error && (
          <div
            role="alert"
            style={{
              padding: "10px 12px",
              marginBottom: 16,
              fontSize: 13,
              color: "var(--danger)",
              background: "var(--danger-soft)",
              borderRadius: "var(--radius)",
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            label="メールアドレス"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
          />
          <TextField
            label="パスワード"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
          <Button
            type="submit"
            variant="primary"
            block
            disabled={loading}
            style={{ marginTop: 4 }}
          >
            {loading ? "ログイン中..." : "ログイン"}
          </Button>
        </form>
      </div>
    </div>
  );
}

export default Login;
